<template>
  <div class="login_wrap">
    <div class="login-hd">
      <span class="sprite-login sprite-login-logo logo" />
      <slot name="title" />
      <span
        v-if="!$slots.title"
        class="title"
      >金山毒霸-快速登录</span>
      <span
        class="btn_close"
        @click="close"
      >
        <i class="sprite-login sprite-login-close" />
      </span>
    </div>
    <!-- 快速登录 -->
    <QuickLogin
      v-show="!isLoopOfficialAccount"
      @emitReportClick="reportClick"
      @emitReportShow="reportShow"
      @emitLoginRespond="handleLoginRespond"
      @emitLoopOfficialAccount="emitLoopOfficialAccount"
    />
    <!-- 手动登录 -->
    <div
      v-show="isLoopOfficialAccount"
      class="manual-login"
    >
      <div class="login_types">
        <div class="login_headline">
          <i :class="['login_icon sprite-login', miniIconClass]" />{{ loginTypeTitle }}
        </div>
        <div
          v-show="!hasPhoneLogin"
          class="wechat_type"
        >
          <OfficialAccountLogin
            v-if="hasOfficialAccountLogin"
            @emitLoginRespond="handleLoginRespond($event, officialAccountLoginType)"
          />
          <template v-else>
            <div
              id="qrcode"
              class="qrcode"
            />
          </template>
        </div>
        <div
          v-show="hasPhoneLogin"
          class="message_type"
        >
          <form
            v-show="!showCaptcha"
            method="post"
            novalidate="true"
            autocomplete="off"
            @submit.prevent.enter="submit"
          >
            <ul>
              <li class="first-li">
                <input
                  id="mobile"
                  v-model="mobile"
                  type="text"
                  name="mobile"
                  placeholder="输入手机号码"
                  @blur="checkForm(1)"
                  @focus="reportClick({ click: 11 })"
                >
              </li>
              <li class="li_error">
                {{ errors[0] }}
              </li>
              <li>
                <input
                  id="verify"
                  v-model="verify"
                  class="verify"
                  type="text"
                  name="verify"
                  maxlength="6"
                  placeholder="输入验证码"
                  @blur="checkForm"
                  @focus="reportClick({ click: 12 })"
                >
                <a
                  class="btn_send"
                  :class="{ disabled: isActive }"
                  @click.prevent="clickSendVerify"
                >{{ showBtnText }}</a>
              </li>
              <li class="li_error">
                {{ errors[1] }}
              </li>
              <li class="last-li">
                <input
                  type="submit"
                  value="登录"
                  class="btn_login"
                >
              </li>
            </ul>
          </form>
          <form
            v-show="showCaptcha"
            method="post"
            novalidate="true"
            autocomplete="off"
            @submit.prevent.enter="submitCaptcha"
          >
            <span class="title">请输入下方面板的字母及数字继续</span>
            <ul>
              <li class="captcha-li">
                <span class="captcha-img-wrap">
                  <img
                    v-if="captchaUrl"
                    :src="captchaUrl"
                    alt=""
                  >
                </span>
                <span
                  class="change-captcha"
                  @click="clickChangeCaptcha"
                ><i class="sprite-login sprite-login-change change" />换一换</span>
              </li>
              <li>
                <input
                  id="captcha"
                  v-model="captcha"
                  type="text"
                  name="captcha"
                  placeholder="请输入图片验证码"
                >
              </li>
              <li class="li_error">
                {{ captchaError }}
              </li>
              <li>
                <input
                  type="submit"
                  value="下一步"
                  class="btn_login"
                >
              </li>
            </ul>
          </form>
        </div>
      </div>
      <!-- 切换登录 -->
      <ChangeLoginType
        v-model="hasPhoneLogin"
        @emitHandleLoign="onHandleLoign"
      />
    </div>
  </div>
</template>

<script>
import login from '@/client/modules/login.js'
import common from '@/client/modules/common.js'
import { formatDate } from '@/utils/shared'
import { WECHAT_LOGIN_APPID, WECHAT_LOGIN_PROXY_URL } from '@/config/config.js'
import { WxLogin } from '@/plugins/wechat/newWxLogin'
import { getCaptchaApi, checkCaptchaApi, sendVerifyCode, updateConvertData } from '@/api/login'
import { getABTestConfig } from '@/api/officialAccountLogin'
import { getOneDayFreeVip } from '@/api/vip'
import { STAY_PAGE_NUM, URL_LIST, REPORT_LOGIN_TYPE, REPORT_PARAMS, OCPC_CONVERT_TYPE } from '@/config/dataMap'
import * as LoginHandler from '@/services/login/loginHandler.js'

import ChangeLoginType from './ChangeLoginType.vue'
import QuickLogin from './QuickLogin.vue'
import OfficialAccountLogin from './OfficialAccountLogin'
import {
  saveToken,
  saveUserInfo
} from '@/utils/cache'

const ERROR_NO_CAPTCHA = '请输入图片验证码'
const ERROR_ERROR_CAPTCHA = '图片验证码错误'

const SMS_CODE = {
  /** 获取验证码 */
  getSmsCode: '-1',
  /** 发送中 */
  sendSmsCode: '-2',
  /** 重发送验证码 */
  resendSmsCode: '-3',
}
const BTN_TEXT_MAP = {
  [SMS_CODE.getSmsCode]: '获取验证码',
  [SMS_CODE.sendSmsCode]: '发送中...',
  [SMS_CODE.resendSmsCode]: '重发送验证码',
}

export default {
  name: 'UserLogin',
  components: { ChangeLoginType, QuickLogin, OfficialAccountLogin },
  props: {
    frm: String,
  },

  data () {
    return {
      errors: [],
      mobile: null,
      verify: null,
      send: false,
      isActive: false,
      count: SMS_CODE.getSmsCode, // 发送验证码按钮文本
      timer: null,
      showCaptcha: false,
      errorTimes: 0,
      maxErrorTimes: 1,
      captchaError: '',
      captcha: '',
      captchaUrl: '',
      isABTest: false, // 公号号 a/b测
      isQuickLogin: false,
      officialAccountLoginType: 7,
      isLoopOfficialAccount: true,
      hasPhoneLogin: false
    }
  },
  computed: {
    showBtnText () {
      return BTN_TEXT_MAP[this.count] || `${this.count}s后重试`
    },

    validCode () {
      const re = /^\d{6}$/
      return re.test(this.verify)
    },

    validPhone () {
      const mobileRule = /(?:^1[3456789]|^9[28])\d{9}$/
      return mobileRule.test(this.mobile)
    },

    // 来源为批量打印功能.兼容客户端的升级问题需要加上活动的showfrom判断
    isSourcePrint () {
      return this.$route.query?.custom === '1' && REPORT_PARAMS.show_from === '6031'
    },

    // 是否有公众号登录
    hasOfficialAccountLogin () {
      return this.isABTest || this.isSourcePrint
    },

    loginTypeTitle () {
      return this.hasPhoneLogin ? '使用手机号登录' : '使用微信登录'
    },

    miniIconClass () {
      return this.hasPhoneLogin ? 'sprite-login-phone-mini' : 'sprite-login-wechat-mini'
    }
  },
  beforeDestroy () {
    if (this.timer) {
      clearInterval(this.timer)
    }
  },
  mounted () {
    this.initSourcePrint()
  },

  methods: {

    initSourcePrint () {
      if (this.isSourcePrint) {
        this.officialAccountLoginType = 7
        this.reportShow(this.officialAccountLoginType)
      }
    },

    // 是否轮询公众号接口
    emitLoopOfficialAccount (status) {
      this.isLoopOfficialAccount = status
      this.init()
    },

    async init () {
      this.isABTest = await this.getOfficialAccountABTest()

      if (!this.isABTest && this.isLoopOfficialAccount) {
        this.createQrcode()
      }

      this.isLoopOfficialAccount && this.reportShow(this.officialAccountLoginType)
    },

    createQrcode () {
      try {
        const origin = `${URL_LIST.wechat}&frm=${this.frm}${this.frm ? '' : '&stopWinClose=0'}&time=${new Date().getTime()}&report_login_type=${this.officialAccountLoginType}`
        const proxyUrl = `${WECHAT_LOGIN_PROXY_URL}?origin=${encodeURIComponent(origin)}`

        new WxLogin({
          self_redirect: false, // false，在当前窗口跳转到指定的redirect_uri
          id: 'qrcode', // 放置微信二维码图片的容器id，例如<div id="login_container"></div>
          appid: WECHAT_LOGIN_APPID,
          scope: 'snsapi_login',
          redirect_uri: encodeURIComponent(`${proxyUrl}`),
          style: 'black',
          href: 'data:text/css;base64,LmltcG93ZXJCb3gge3RleHQtYWxpZ246IGxlZnQ7fQouaW1wb3dlckJveCAucXJjb2RlIHt3aWR0aDogMTcwcHg7IG1hcmdpbi10b3A6IDA7IGJvcmRlcjogbm9uZTt9Ci5pbXBvd2VyQm94IC50aXRsZSB7ZGlzcGxheTogbm9uZTt9Ci5zdGF0dXNfaWNvbiB7ZGlzcGxheTogbm9uZX0KLmltcG93ZXJCb3ggLnN0YXR1cyB7dGV4dC1hbGlnbjogY2VudGVyO30KLnBhbmVsQ29udGVudCB7dGV4dC1hbGlnbjogY2VudGVyO30gLmpzX3d4X2RlZmF1bHRfdGlwIHtkaXNwbGF5OiBmbGV4OyBqdXN0aWZ5LWNvbnRlbnQ6IGNlbnRlcjt9IC53ZWJfcXJjb2RlX3N3aXRjaF93cnAge21hcmdpbi10b3A6IHVuc2V0OyB0ZXh0LWFsaWduOiBjZW50ZXI7fSAubm9ybWFsUGFuZWwge21hcmdpbi10b3A6IC0xMHB4O30gLmpzX3d4X2RlZmF1bHRfdGlwIHA6bnRoLWNoaWxkKDIpIHtkaXNwbGF5OiBub25lO30gLmluZm8gLmpzX3d4X2FmdGVyX3NjYW4sIC5pbmZvIC5qc193eF9hZnRlcl9jYW5jZWwge2Rpc3BsYXk6bm9uZSAhaW1wb3J0YW50fQ==',
          fast_login: 1, // ，默认支持快捷登录
        })
        const show_time = formatDate(new Date())
        login.REPORT.reportLoginPageShow({ show_time, login_type: this.officialAccountLoginType, page_show: 3 })
      } catch (err) {
        const show_time = formatDate(new Date())
        login.REPORT.reportLoginPageShow({ show_time, login_type: this.officialAccountLoginType, page_show: 4 })
      }
    },

    onHandleLoign () {
      const showLoginType = this.hasPhoneLogin ? REPORT_LOGIN_TYPE.phone : this.officialAccountLoginType

      this.reportShow(showLoginType)
    },

    async clickSendVerify () {
      this.reportClick({ click: 4 })

      if (this.checkForm(1) && !this.send) {
        const params = {
          mobile: this.mobile,
          captcha: this.captcha || '0000',
        }
        const data = await sendVerifyCode(params)
        if (data) {
          if (data.mobile_calc) {
            this.errorTimes = data.mobile_calc
          }
          if (data.mobile_max_calc) {
            this.maxErrorTimes = data.mobile_max_calc
          }

          if (this.errorTimes > this.maxErrorTimes) {
            this.reportClick({ click: 16 })

            this.showCaptcha = true
            this.getCaptcha()
            return
          }

          this.send = true
          this.count = SMS_CODE.sendSmsCode
          this.countDown()
        }
      }
    },

    clickChangeCaptcha () {
      this.reportClick({ click: 17 })
      this.getCaptcha()
    },

    sendVerify () {
      this.send = true
      this.count = SMS_CODE.sendSmsCode
      this.countDown()

      const params = {
        mobile: this.mobile,
        captcha: this.captcha || '0000',
      }

      // 延时1秒发送请求, 因为服务端需要1秒后才重置错误次数
      setTimeout(() => {
        sendVerifyCode(params)
      }, 1000)
    },

    countDown () {
      let count = 60
      this.timer = setInterval(() => {
        if (count == 0) {
          this.reset()
          return
        }
        this.count = count--
        this.isActive = true
      }, 1000)
    },

    reset () {
      this.send = false
      this.isActive = false
      clearInterval(this.timer)
      this.count = SMS_CODE.resendSmsCode
    },

    checkForm (type) {
      this.errors = []

      if (!this.mobile) {
        this.errors[0] = '请输入手机号'
        return false
      } else if (!this.validPhone) {
        this.errors[0] = '请输入正确手机号'
        return false
      }

      if (type == 1) {
        return true
      }

      if (!this.verify) {
        this.errors[1] = '请输入验证码'
        return false
      } else if (!this.validCode) {
        this.errors[1] = '请输入6位数字'
        return false
      }

      return true
    },

    async getCaptcha () {
      const { resp_common, captcha } = await getCaptchaApi({ mobile: this.mobile })
      if ((resp_common && resp_common.ret != 0) || !captcha) return

      this.captchaUrl = captcha
      this.captcha = ''
    },

    async submitCaptcha () {
      this.reportClick({ click: 18 })

      if (!this.checkCaptchaForm()) return

      const params = { mobile: this.mobile, captcha: this.captcha }
      const { resp_common, status, mobile_calc, mobile_max_calc } = await checkCaptchaApi(params)

      if ((resp_common && resp_common.ret != 0) || (status != 1)) {
        this.captchaError = ERROR_ERROR_CAPTCHA
        return
      }

      this.showCaptcha = false
      this.captchaError = ''

      if (mobile_calc) {
        this.errorTimes = mobile_calc
      }
      if (mobile_max_calc) {
        this.maxErrorTimes = mobile_max_calc
      }

      // 验证正确，发送短信
      this.sendVerify()
    },

    checkCaptchaForm () {
      if (!this.captcha) {
        this.captchaError = ERROR_NO_CAPTCHA
        return false
      }
      return true
    },

    submit () {
      this.reportClick({ click: 3 })

      if (!this.checkForm() || this.errors.length > 0) return

      this.reportResult({
        result: 3,
        reason: '',
        login_type: REPORT_LOGIN_TYPE.phone,
      })
      LoginHandler.login({ tel: this.mobile, tel_code: this.verify })
        .then((data) => {
          this.handleLoginRespond(data, REPORT_LOGIN_TYPE.phone)
        })
        .catch((e) => {
          const reason = '其它'
          this.loginError(reason, REPORT_LOGIN_TYPE.phone)
          console.error(e)
        })
    },

    /** 公众号ab测试 */
    async getOfficialAccountABTest () {
      try {
        const { data } = await getABTestConfig()

        this.officialAccountLoginType = data.infoc_login_type // 优先使用接口返回的上报值
        return data.wx_mp_login_enable
      } catch (error) {
        return false
      }
    },

    handleLoginRespond (res, login_type) {
      const ret = res.resp_common.ret

      // 先处理特殊状态码
      if (ret === 5904001) {
        this.haveMigration()
        return
      }

      const data = res.data
      this.reportResult({
        result: 4,
        reason: '',
        login_type: login_type,
        openid: data.user_info.open_id,
        vip_status: data.user_info.is_continuous === '1' ? 1 : 2,
        is_vip: data.user_info.vip_type === 0 ? 0 : 1,
      })

      const statusCodeMap = {
        0: () => { this.loginSuccess(data, login_type) },
        3001002: () => { this.loginAuthCodeError(login_type) },
        5903006: () => { this.loginLimit(data, res, login_type) }
      }

      // 使用状态码映射对象处理登录结果
      statusCodeMap[ret] ? statusCodeMap[ret]() : this.loginError(ret, login_type)
    },

    /** 登录成功 */
    async loginSuccess (data, login_type) {
      this.reportResult({
        result: 1,
        reason: '',
        login_type: login_type,
        openid: data.user_info.open_id,
        vip_status: data.user_info.is_continuous === '1' ? 1 : 2,
        is_vip: data.user_info.vip_type === 0 ? 0 : 1,
      })
      saveToken(data.token)
      saveUserInfo(data.user_info)
      try {
        const res = await common.API.getOcpcUrl()
        await updateConvertData({
          conversion_info: {
            long_code: res.logidUrl,
            convert_type: OCPC_CONVERT_TYPE.LOGIN,
            user_type: res.userType > 0 ? res.userType : 1,
          }
        })
      } catch (e) {
        common.API.client_winclose({
          token: data.token,
          open_id: data.user_info.open_id,
          type: login_type,
        })
        window.close()
      }
      await getOneDayFreeVip()
      common.API.client_winclose({
        token: data.token,
        open_id: data.user_info.open_id,
        type: login_type,
      })
      window.close()
    },

    /** 登录验证码错误 */
    loginAuthCodeError (login_type) {
      this.reportResult({
        result: 2,
        reason: '验证码错误',
        login_type: login_type,
        openid: '',
        vip_status: 0,
      })
      this.$set(this.errors, 1, '验证码错误')
    },

    /** 登录限制 */
    loginLimit (data, res, login_type) {
      this.$toast(`登录设备达到上限，同一会员账号允许最多在${res.limit}台设备登录`, {
        duration: 2000,
        callback: () => {
          // 客户端弹出登录受限框
          LoginHandler.openDeviceAdmin(data.token, data.user_info.open_id)
        }
      })

      this.reportResult({
        result: 2,
        reason: '登录设备限制',
        login_type: login_type,
        openid: '',
        vip_status: 0,
      })
    },

    /** 账号已经被迁移 */
    haveMigration () {
      common.API.client_openOptionWindow({
        url: `${window.location.origin}/${buildChannel}/upgrade-client`,
        width: 400,
        height: 180,
        open_web: 'upgrade-client_one'
      })
      window.close()
    },

    /** 登录失败 */
    loginError (ret, login_type) {
      this.reportResult({
        result: 2,
        reason: ret.toString(),
        login_type: login_type,
        openid: '',
        vip_status: 0,
      })
      console.error(ret)
    },

    close () {
      this.reportClick({ click: 10, login_type: this.officialAccountLoginType })
      login.REPORT.reportCenterStayTimeKfmt({ show_page: STAY_PAGE_NUM[this.$route.name] })

      window.close()
    },

    reportShow (login_type = 0) {
      const show_time = formatDate(new Date())
      login.REPORT.reportLoginPageShow({ show_time, login_type })
    },

    reportClick ({ click = 0, login_type = 0 }) {
      const show_time = formatDate(new Date())

      login.REPORT.reportLoginPageClick({
        page_click: click,
        show_time,
        login_type
      })
    },

    reportResult ({
      result = 0,
      reason = '',
      login_type = 1,
      openid = '',
      vip_status = 0,
      is_vip = 0,
    }) {
      const show_time = formatDate(new Date())
      login.REPORT.reportLoginPageResult({
        result,
        reason,
        login_type,
        openid,
        vip_status,
        show_time,
        is_vip,
      })
    }

  },
}
</script>

<style scoped lang="scss">
@import '@/assets/css/sprite-login.scss';

.login_wrap {
  position: relative;
  margin: 0 auto;
  width: 350px;
  height: 480px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 4px 15px 0px rgba(0, 0, 0, 0.25);
  box-sizing: border-box;
  .login-hd {
    -webkit-app-region: drag;
    box-sizing: border-box;
    height: 50px;
    position: relative;
    overflow: hidden;
    border-top: 6px solid #fdd63c;
    .logo {
      width: 16px;
      height: 16px;
      position: absolute;
      top: 7px;
      left: 8px;
    }
    .title {
      position: absolute;
      left: 27px;
      top: 7px;
      color: #b07400;
      font-size: 12px;
    }
    .btn_close {
      -webkit-app-region: no-drag;
      position: absolute;
      right: 0;
      width: 24px;
      height: 24px;
      cursor: pointer;
      overflow: hidden;
      i {
        position: relative;
      }
      &:hover {
        i {
          left: -24px;
        }
      }
      &:active {
        i {
          left: -48px;
        }
      }
    }
  }
  .btn_login {
    outline: none;
    width: 252px;
    height: 38px;
    line-height: 38px;
    background: #de461e;
    color: #fff;
    text-align: center;
    border-radius: 20px;
    font-size: 16px;
    cursor: pointer;
    -webkit-box-shadow: none;
    border: none;
  }
}

.manual-login {
  .login_types {
    height: 270px;
  }
  .login_headline{
    height: 36px;
    line-height: 36px;
    text-align: center;
    color: #333333;
    font-size: 14px;
    .login_icon{
      margin-right: 8px;
    }
  }
  .wechat_type {
    padding-top: 13px;
    text-align: center;
    .title {
      font-size: 18px;
      color: #797979;
      display: inline-block;
      line-height: 34px;
    }
    iframe {
      width: 170px;
      height: 170px;
    }
    .qrcode {
      // width: 170px;
      // height: 170px;
      display:flex;
      justify-content: center;
      margin: 0 auto;
    }
  }
  .message_type {
    width: 252px;
    margin: 0 auto;
    .title {
      font-size: 12px;
      color: #797979;
      margin: 10px 0 6px;
      display: inline-block;
    }
    li {
      height: 40px;
      &.li_error {
        height: 16px;
        color: #ff3f3f;
        font-size: 12px;
        margin-bottom: 2px;
      }
    }
    .first-li {
      padding-top: 28px;
    }

    .last-li {
      margin-top: 12px;
    }

    .captcha-li {
      width: 254px;
      height: 50px;
      margin-bottom: 9px;
      .captcha-img-wrap,
      img {
        display: inline-block;
        vertical-align: middle;
        width: 210px;
        height: 50px;
      }
      .change-captcha {
        width: 36px;
        font-size: 12px;
        color: #636d78;
        display: inline-block;
        vertical-align: middle;
        text-align: center;
        margin-left: 8px;
        .change {
          width: 26px;
          height: 29px;
          display: inline-block;
          cursor: pointer;
        }
      }
    }

    input[type='text'] {
      height: 40px;
      width: 252px;
      box-sizing: border-box;
      padding-left: 10px;
      border: solid 1px #d0d0d0;
      outline: none;
      box-shadow: none;
      font-family: 'MicrosoftYaHei', 'Microsoft YaHei', 'Arial', '\9ED1\4F53',
        '\5B8B\4F53', '\5FAE\8F6F\96C5\9ED1', sans-serif;
      &::selection {
        background: #2593ff;
        color: #fff;
      }
    }
    input[type='text'].verify {
      width: 149px;
    }

    .btn_send {
      display: inline-block;
      width: 97px;
      height: 40px;
      box-sizing: border-box;
      margin-left: 4px;
      vertical-align: middle;
      position: relative;
      top: -1px;
      color: #de461e;
      line-height: 40px;
      background: #fff;
      font-size: 12px;
      border: solid 1px #d0d0d0;
      text-align: center;
      cursor: pointer;
      &:hover {
        border-color: #de461e;
      }
    }
    .disabled {
      border-color: #ddd;
      background-color: #ddd;
      color: #fff;
      cursor: auto;
      &:hover {
        border-color: #ddd;
      }
    }
  }
}
</style>
